<template>
  <div class="app-no-payment-data-view">
      <slot name="txtBefore"><h1>Direktaufladung</h1>
        <p>Ganz einfach und bequem Guthaben aufladen: Flexible Bezahlung per Bankeinzug oder Kreditkarte.</p></slot>
    <b-button :href="url" class="btn-add-payment-information">
        <slot name="txtBtn">Direktaufladung aktivieren</slot>
    </b-button>

    <slot name="txtAfter">
    </slot>
  </div>
</template>

<script>

export const stepName = 'noPaymentData'

export default {
  name: 'NoPaymentDataView',
  props: {
    url: {
      type: String,
      default: '/'
    }
  }
}
</script>
